import { Component, OnInit } from "@angular/core";



import { Router } from "@angular/router";
import { Globals } from "../globals";
import { AutorizacionService } from "../autorizacion.service";
import { AngularFireAuth } from '@angular/fire/auth';
import * as firebase from "firebase";
import Swal from "sweetalert2";
import { FormBuilder, FormGroup } from "@angular/forms";
@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"]
})
export class LoginComponent implements OnInit {
  user: any;
  mostrarComponentes: boolean = false;

  formCorreo:FormGroup
  formCodigo:FormGroup
  verCodigo=false;

  constructor(
    private autorizacionService: AutorizacionService,

    private router: Router,
    public globals: Globals,
    private afAuth: AngularFireAuth,
    private fb:FormBuilder
  ) {}

  crearFormCorreo ()
{
  this.formCorreo = this.fb.group({
    correo:[''],

  })

  this.formCodigo = this.fb.group({
    codigo:[''],

  })
}


enviarCorreo(){
  let validacion = this.autorizacionService.consultarDatosUsuarioExterno(this.formCorreo.value['correo']).subscribe(datos=>{

    if(datos){
      if(datos[0]){
        let form = {
          para:this.formCorreo.value['correo'],
          codigo: this.generarCodigoAlfanumerico()
        }


        this.autorizacionService.enviarCorreoInicio(form).subscribe(dataLogin=>{
          console.log(dataLogin)
          this.verCodigo = true
        })
      }
       else{
        Swal.fire(
          "No te encuentras registrado en el modulo Compliance frontera, contacta con a el administrador"
        );

       }
    }

  })
}


enviarCodigo(){
  this.autorizacionService.enviarCodigo(this.formCodigo.value['codigo']).subscribe(dataCodigo=>{
    console.log(dataCodigo)
    if(dataCodigo && dataCodigo[0]){
    if(dataCodigo[0].codigo == this.formCodigo.value['codigo']){

      this.autorizacionService.consultarDatosUsuario(this.formCorreo.value['correo']).subscribe(datos => {
        console.log(datos)
      this.globals.CorreoUsuario = datos[0].correo_corporativo;
      this.globals.IdFuncionarioTablaFuncionarios = datos[0].idtbl_funcionario;
      this.globals.NombreCompletoUsuario = datos[0].nombre_completo;
      this.globals.SuperAdministrador = datos[0].super_admin;
      this.globals.IdSapFrontera = datos[0].idfronteraok;
      this.globals.lenguaje = datos[0].idioma.toLowerCase();

      if (
        this.globals.lenguaje == "en" ||
        this.globals.lenguaje == "ingles"
      ) {
        this.globals.lenguaje = "en";
      } else {
        this.globals.lenguaje = "es";
      }

      this.globals.EstaAuntenticado = true;

      let infoUser = {
        correo:datos[0].correo_corporativo,
        id_funcionario:datos[0].idtbl_funcionario,
        displayName:datos[0].nombre_completo,
        SuperAdministrador:datos[0].super_admin,
        sap:datos[0].idfronteraok,
        lenguaje:datos[0].idioma.toLowerCase()
      }

      localStorage.setItem('tipoAuth','correo')
      localStorage.setItem('correo', JSON.stringify(infoUser))

      this.mostrarComponentes = true;

      this.router.navigate(["/inicio"]);

    }
      )}

    else{
      Swal.fire(
        "El código de verificación no es válido, por favor intenta nuevamente"
      );
    }
  } else{
    Swal.fire(
      "El código de verificación no es válido, por favor intenta nuevamente"
    );
  }
  })

}

 generarCodigoAlfanumerico() {
  const caracteres = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const longitudCodigo = 6;
  let codigo = '';

  for (let i = 0; i < longitudCodigo; i++) {
    const indiceAleatorio = Math.floor(Math.random() * caracteres.length);
    codigo += caracteres.charAt(indiceAleatorio);
  }

  return codigo;
}

  ngOnInit() {
    this.crearFormCorreo()

    //////conole.log(this.user);
    this.afAuth.authState.subscribe(user => {
      this.user = user;
      console.log(user)

      if (user) {
        //////conole.log("logueado");
        this.globals.EstaAuntenticado = true;

        this.autorizacionService.consultarDatosUsuario(user.email).subscribe(datos => {
          //////conole.log(datos);

          try {
            //////conole.log(datos[0].correo_corporativo);
          }
          catch(err) {


            Swal.fire(
              "No te encuentras registrado en el modulo Compliance frontera, contacta con a el administrador"
            );

            this.signOut();


          }

          //////conole.log(this.globals.lenguaje);

          this.globals.CorreoUsuario = datos[0].correo_corporativo;
          this.globals.IdFuncionarioTablaFuncionarios = datos[0].idtbl_funcionario;
          this.globals.NombreCompletoUsuario = datos[0].nombre_completo;
          this.globals.SuperAdministrador = datos[0].super_admin;
          this.globals.IdSapFrontera = datos[0].idfronteraok;
          this.globals.lenguaje = datos[0].idioma.toLowerCase();

          if (
            this.globals.lenguaje == "en" ||
            this.globals.lenguaje == "ingles"
          ) {
            this.globals.lenguaje = "en";
          } else {
            this.globals.lenguaje = "es";
          }


          let infoUser = {
            correo:datos[0].correo_corporativo,
            id_funcionario:datos[0].idtbl_funcionario,
            displayName:datos[0].nombre_completo,
            SuperAdministrador:datos[0].super_admin,
            sap:datos[0].idfronteraok,
            lenguaje:datos[0].idioma.toLowerCase()
          }

          localStorage.setItem('tipoAuth','ms')
          localStorage.setItem('correo', JSON.stringify(infoUser))

          this.mostrarComponentes = true;



          this.router.navigate(["/inicio"]);

          switch (this.router.url) {
            case "/administradorconflictos":
              break;
            case "/administrar-usuario":
              if (this.globals.SuperAdministrador == "0") {
                Swal.fire(
                  "No tienes permisos para usar el modulo de administracion de usuarios(Contacta con el administrador del sistema)"
                );

                this.signOut();
              }
              break;
            default:
              //////conole.log("default");
          }
        });
      } else {
        //////conole.log("nologuedo");
        this.globals.EstaAuntenticado = false;
        this.globals.RutaDeRedireccion = this.router.url;
        this.router.navigate(["/login"]);
        this.globals.EstaAuntenticado = false;

        this.mostrarComponentes = true;
      }
    });
  }


  // signInWithGoogle(): void {
  //   this.authService.signIn(GoogleLoginProvider.PROVIDER_ID);
  // }

  loginWithMicrosoft() {

    const provider = new firebase.auth.OAuthProvider('microsoft.com')
    provider.setCustomParameters({
    // tenant: '2637d50c-c560-436c-8997-ebe63c9656fd',
     tenant: '2637d50c-c560-436c-8997-ebe63c9656fd',
    })
    this.afAuth.auth.signInWithPopup(provider)


   }

  signOut(): void {
  //  this.authService.signOut();
    this.afAuth.auth.signOut()
  }
}
